import React from 'react';
import { Switch } from 'antd';
import classNames from 'classnames';
import { useThemeVarsClass } from '../../../theme/provider';

import cn from './styles.module.scss';

export type ToggleProps = {
  checked: boolean,
  onChange: (event: React.MouseEvent<HTMLDivElement>, checked: boolean) => void,
  disabled?: boolean,
  className?: string,
  classes?: { label?: string, toggle?: string },
  children?: any,
  'data-testid'?: string
};

export function Toggle({
  checked,
  onChange,
  disabled,
  className,
  classes = {},
  children,
  ...props
}: ToggleProps) {
  const themeClassName = useThemeVarsClass();
  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (!disabled) {
      onChange(event, !checked);
    }
  };

  return (
    <div onClick={handleClick} className={classNames(cn.container, themeClassName, className, { [cn.disabled]: disabled })}>
      <Switch
        size="small"
        checked={checked}
        disabled={disabled}
        className={classNames(
          classes.toggle,
          cn.toggle,
          {
            [cn.checked]: checked,
            [cn.disabled]: disabled,
          },
        )}
        {...props}
      />
      <span className={classNames(cn.label, classes.label)}>
        {children}
      </span>
    </div>

  );
}
